import axios from 'axios';
import Helpers from "./Helpers"
import { APIUrl, LanguageCode } from "./Conf";
import LocalDataStore from './LocalDataStore';
import TokenStore from './TokenStore';
const qs = require("qs");

class DC {
    static header() {
        let result = {
            'lnc': LanguageCode,
            'token': TokenStore.get(),
            'lId': LocalDataStore.locationIdGet()
        };
        return result;
    }

    public static async Post(url: string, postData: any) {
        const response = await axios({
            method: 'post',
            url: APIUrl + url,
            data: qs.stringify(postData),
            headers: this.header()
        }).catch(error => {
            console.log(error);
        });

        if (response !== undefined) return { wasOk: true, data: response.data };
        else return { wasOk: false };
    }

    public static async PostForm(url: string, form: any) {
        const data = new FormData(form.current);
        const response = await axios({
            method: 'post',
            url: APIUrl + url,
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).catch(error => {
            console.log(error);
        });

        if (response !== undefined) return { wasOk: true, data: response.data };
        else return { wasOk: false };
    }

    public static async PostData(url: string, postData: any) {
        const result: any = { wasOk: true, status: 200, data: undefined }
        const response = await axios({
            method: 'post',
            url: APIUrl + url,
            data: postData,
            headers: await this.header()
        }).catch(error => {
            console.log(error);
            result.wasOk = false;
            result.status = error.response ? error.response.status : 500;
            result.data = error.response.data;
        });
        if (response !== undefined)
            result.data = response.data;
        return result;
    }

    public static async Patch(url: string, postData: any) {
        const response = await axios({
            method: 'patch',
            url: APIUrl + url,
            data: qs.stringify(postData),
            headers: this.header()
        }).catch(error => {
            console.log(error);
        });

        if (response !== undefined) return { wasOk: true, data: response.data };
        else return { wasOk: false };
    }

    public static async Get(url: string, data?: any) {
        url = url + (data ? '?' + Helpers.ObjectToQueryString(data) : '');

        const response = await axios({
            method: 'get',
            url: APIUrl + url,
            headers: this.header()
        }).catch(error => {
            console.log(error);
        });

        if (response !== undefined) return { wasOk: true, data: response.data };
        else return { wasOk: false };
    }

    public static async Delete(url: string) {
        const response = await axios({
            method: 'delete',
            url: APIUrl + url,
            headers: this.header()
        }).catch(error => {
            console.log(error);
        });

        if (response !== undefined) return { wasOk: true, data: response.data };
        else return { wasOk: false };
    }
}
export default DC;